const AppSettings = {
    // serverUrl: "https://api-alpha.myseniorcenter.net",

    // serverUrl: "https://core-mac-isitbroken.myactivecenter.com",
    // serverUrl: "https://core-kiosk-alpha.myseniorcenter.net",
    // Currently Using

    // serverUrl: "https://api-mobile.myseniorcenter.net", //using

    // serverUrl: "https://api-mac-isitbroken.myactivecenter.com",

    // serverUrl: "https://api-kiosk-production.myseniorcenter.net",

    serverUrl: "https://api-test.myseniorcenter.net", // using for test

    BASE_S3_URL: "https://myseniorcenter-tenants.s3.amazonaws.com",

    // appType: "volunteers",
    // appType: "mow",
    // appType: "drivers",
    appType: "mow",
    dynamicCacheName: "runtimeCache-rides-v0.1.5",
    version: "0.1",
    indexedDBVersion: 3,
};
export default AppSettings;
